import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { ProjetListState } from './state';
import { Chantier } from '@/models/Chantier';

export const getters: GetterTree<ProjetListState, RootState> = {
    getListValue(state): Chantier[] {
        return state.projetList;
    },
    getCurrentPage(state): number {
        return state.page;
    },
    getNumberOfPages(state): number {
        return state.pages;
    },
    getError(state): boolean {
        return state.error;
    },
    getIsLoading(state): boolean {
        return state.isLoading;
    },
    getFilter(state): string {
        return state.filter;
    },
    getScroll(state): number {
        return state.scroll;
    },
    getSiteId(state): number {
        return state.projetId;
    },
};
